(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-cross-sell-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
  // Fire-and-forget tracking beacon, added Sep 14 2026 -- lets Akshat
  // query which cross-sell designs actually get picked. Wrapped so it
  // can NEVER throw or block the real add-to-cart above; sendBeacon
  // survives the cart drawer closing/navigating away right after the
  // click, which a plain fetch would not.
  function trackCrossSellAdd(card) {
    try {
      var payload = JSON.stringify({
        variant_id: parseInt(card.dataset.variantId, 10),
        product_handle: card.dataset.productHandle || null,
        product_title: card.dataset.productTitle || null,
      });
      var url = 'https://ops.slapthatpatch.com/api/cross-sell-track';
      if (navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));
      } else {
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true });
      }
    } catch (e) {
      // never let tracking break the real add-to-cart flow
    }
  }

  // Tapping a card (anywhere but Add) opens the product in the quick-add
  // popup instead of going to the product page. quick-add.js and
  // product-form.js only ship with card sections, so load them if missing.
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var el = document.createElement('script');
      el.src = src;
      el.onload = resolve;
      el.onerror = reject;
      document.head.appendChild(el);
    });
  }

  function crossSellModal() {
    var existing = document.getElementById('QuickAdd-cross-sell');
    if (existing && existing.parentElement === document.body) return Promise.resolve(existing);
    var tpl = document.querySelector('template[data-cart-cross-sell-modal]');
    if (!tpl) return Promise.reject(new Error('no cross-sell modal template'));
    if (!document.querySelector('link[href="' + tpl.dataset.qaCss + '"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = tpl.dataset.qaCss;
      document.head.appendChild(link);
    }
    var ready = Promise.resolve();
    if (!customElements.get('product-form')) ready = ready.then(function () { return loadScript(tpl.dataset.formJs); });
    if (!customElements.get('quick-add-modal')) ready = ready.then(function () { return loadScript(tpl.dataset.qaJs); });
    return ready.then(function () {
      var modal = tpl.content.firstElementChild.cloneNode(true);
      document.body.appendChild(modal);
      // Closing the popup clears body.overflow-hidden; keep it while the drawer is open.
      document.body.addEventListener('modalClosed', function () {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.classList.contains('active')) document.body.classList.add('overflow-hidden');
      });
      return modal;
    });
  }

  function openCrossSellProduct(card) {
    if (card.getAttribute('aria-disabled') === 'true') return;
    crossSellModal()
      .then(function (modal) { modal.show(card); })
      .catch(function () { window.location.href = card.dataset.productUrl; });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-cross-sell-add]')) return;
    var card = event.target.closest('.cart-cross-sell__card[data-product-url]');
    if (card) openCrossSellProduct(card);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var card = event.target.closest && event.target.closest('.cart-cross-sell__card[data-product-url]');
    if (!card || event.target !== card) return;
    event.preventDefault();
    openCrossSellProduct(card);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-cross-sell-add]');
    if (!button) return;

    var card = button.closest('.cart-cross-sell__card');
    if (!card) return;

    var variantId = parseInt(card.dataset.variantId, 10);
    button.disabled = true;
    var originalText = button.textContent;
    button.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function () {
        trackCrossSellAdd(card);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-cross-sell' });
        }
        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { source: 'cart-cross-sell' } })
        );
      })
      .finally(function () {
        button.disabled = false;
        button.textContent = originalText;
      });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-unlock-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  var MIN_SUBTOTAL_CENTS = 28500; // ₹285 -- keep in sync with cart-drawer.liquid / main-cart-footer.liquid

  // IMPORTANT: the cart drawer (and the full /cart page) replace large
  // chunks of their own innerHTML wholesale on every cart update (see
  // cart-drawer.liquid's `cart:updated` listener, which re-fetches
  // `/cart?view=drawer` and swaps #CartDrawer's innerHTML). That destroys
  // whatever modal DOM node existed before and creates a brand new one --
  // any listener attached directly to a specific modal element, or any
  // function closure that captured a reference to it, goes stale and
  // silently does nothing on the next open. Fixed by: (1) delegating every
  // click on `document` (never destroyed, so it keeps working no matter
  // how many times the modal underneath it gets replaced), and (2) always
  // resolving the modal via a fresh getElementById at open-time rather
  // than a captured variable -- the fresh node is also correctly
  // re-filtered server-side against the current cart (already-added
  // products drop out of the list automatically).

  function getModal(ctx) {
    return document.getElementById('CartUnlockModal-' + ctx);
  }

  // Mirrors cart-cross-sell-carousel.liquid's already-rendered cards rather
  // than running a second independent product lookup (see this file's doc
  // comment for why). 'drawer' reads the carousel inside the cart drawer;
  // 'page' reads the one inside the full /cart page's item list -- both
  // can exist on the DOM at once on the /cart page itself.
  function getCarouselScope(ctx) {
    var scopeSelector = ctx === 'page' ? '#main-cart-items' : '#CartDrawer-CartItems';
    return document.querySelector(scopeSelector);
  }

  function populateModalList(modal, ctx) {
    var listEl = modal.querySelector('[data-cart-unlock-list]');
    var emptyEl = modal.querySelector('[data-cart-unlock-empty]');
    if (!listEl) return;

    Array.prototype.slice.call(listEl.querySelectorAll('[data-cart-unlock-row]')).forEach(function (row) {
      row.remove();
    });

    var scope = getCarouselScope(ctx);
    var cards = scope ? scope.querySelectorAll('.cart-cross-sell__card') : [];

    if (emptyEl) emptyEl.hidden = cards.length > 0;

    cards.forEach(function (card) {
      var variantId = card.getAttribute('data-variant-id');
      var title = card.getAttribute('data-product-title') || '';
      var imgEl = card.querySelector('.cart-cross-sell__image');
      var nameEl = card.querySelector('.cart-cross-sell__name');
      var priceEl = card.querySelector('.cart-cross-sell__price');

      var row = document.createElement('div');
      row.className = 'cart-unlock-modal__row';
      row.setAttribute('data-cart-unlock-row', '');
      row.setAttribute('data-variant-id', variantId);

      var thumb = document.createElement('img');
      thumb.className = 'cart-unlock-modal__thumb';
      thumb.loading = 'lazy';
      thumb.alt = title;
      if (imgEl) thumb.src = imgEl.src;

      var info = document.createElement('div');
      info.className = 'cart-unlock-modal__info';

      var name = document.createElement('p');
      name.className = 'cart-unlock-modal__name';
      name.textContent = nameEl ? nameEl.textContent.trim() : title;
      var badgeEl = card.querySelector('.cart-cross-sell__badge');
      if (badgeEl) name.textContent = '📦 ' + badgeEl.textContent.trim() + ' · ' + name.textContent;

      var priceP = document.createElement('p');
      priceP.className = 'cart-unlock-modal__price';
      if (priceEl) priceP.innerHTML = priceEl.innerHTML;

      info.appendChild(name);
      info.appendChild(priceP);

      var addBtn = document.createElement('button');
      addBtn.type = 'button';
      addBtn.className = 'cart-unlock-modal__add';
      addBtn.setAttribute('data-cart-unlock-add', '');
      addBtn.textContent = 'ADD';

      row.appendChild(thumb);
      row.appendChild(info);
      row.appendChild(addBtn);
      listEl.appendChild(row);
    });
  }

  function updateConfirmButton(modal) {
    var confirmBtn = modal.querySelector('[data-cart-unlock-confirm]');
    if (!confirmBtn) return;
    var stagedCount = modal.querySelectorAll('[data-cart-unlock-row].cart-unlock-modal__row--staged').length;
    confirmBtn.textContent = stagedCount > 0
      ? ('Add ' + stagedCount + ' product' + (stagedCount > 1 ? 's' : '') + ' to Cart')
      : 'Add products to Cart';
    confirmBtn.disabled = stagedCount === 0;
  }

  function openModal(ctx) {
    var modal = getModal(ctx);
    if (!modal) return;
    var gapEl = modal.querySelector('[data-cart-unlock-gap]');

    populateModalList(modal, ctx);
    updateConfirmButton(modal);

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var remainingRupees = Math.ceil((MIN_SUBTOTAL_CENTS - cart.items_subtotal_price) / 100);
        if (gapEl) {
          gapEl.textContent = remainingRupees > 0
            ? ('Add ₹' + remainingRupees + ' more to unlock checkout')
            : 'You can checkout now!';
        }
      })
      .catch(function () {})
      .finally(function () {
        modal.setAttribute('aria-hidden', 'false');
        modal.classList.add('cart-unlock-modal--visible');
      });
  }

  window.openCartUnlockModal_drawer = function () { openModal('drawer'); };
  window.openCartUnlockModal_page = function () { openModal('page'); };

  document.addEventListener('click', function (event) {
    var modal = event.target.closest('.cart-unlock-modal');
    if (!modal) return;

    if (event.target.closest('[data-cart-unlock-close]')) {
      modal.classList.remove('cart-unlock-modal--visible');
      return;
    }

    var addBtn = event.target.closest('[data-cart-unlock-add]');
    if (addBtn) {
      var row = addBtn.closest('[data-cart-unlock-row]');
      var isStaged = row.classList.toggle('cart-unlock-modal__row--staged');
      addBtn.textContent = isStaged ? '✓ Added' : 'ADD';
      addBtn.classList.toggle('cart-unlock-modal__add--added', isStaged);
      updateConfirmButton(modal);
      return;
    }

    var confirmBtn = event.target.closest('[data-cart-unlock-confirm]');
    if (confirmBtn && !confirmBtn.disabled) {
      var stagedRows = modal.querySelectorAll('[data-cart-unlock-row].cart-unlock-modal__row--staged');
      var items = Array.prototype.map.call(stagedRows, function (row) {
        return { id: parseInt(row.getAttribute('data-variant-id'), 10), quantity: 1 };
      });
      if (items.length === 0) return;

      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function () {
          modal.classList.remove('cart-unlock-modal--visible');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-unlock-modal' });
          }
          document.dispatchEvent(
            new CustomEvent('cart:updated', { detail: { source: 'cart-unlock-modal' } })
          );
        })
        .catch(function () {
          // Leave items staged so the customer can retry rather than
          // silently losing their selection.
        })
        .finally(function () {
          updateConfirmButton(modal);
        });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-size-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    function money(paise) {
      return '₹' + Math.round(paise / 100);
    }

    function init(root) {
      if (root.__stpCustomSizeInit) return;
      root.__stpCustomSizeInit = true;
      var cfgEl = root.querySelector('[data-stp-custom-size-config]');
      var overlay = root.querySelector('[data-stp-custom-size-overlay]');
      if (!cfgEl || !overlay) return;
      var cfg = JSON.parse(cfgEl.textContent);
      var sizes = cfg.sizes.slice().sort(function (a, b) { return a.size - b.size; });
      if (!sizes.length) { root.hidden = true; return; }
      var minSize = sizes[0].size;
      var maxSize = sizes[sizes.length - 1].size;
      var qty = {};
      var rowsEl = root.querySelector('[data-stp-custom-size-rows]');
      var otherInput = root.querySelector('[data-stp-custom-size-other]');
      var otherPrice = root.querySelector('[data-stp-custom-size-other-price]');
      var otherError = root.querySelector('[data-stp-custom-size-other-error]');
      var addBtn = root.querySelector('[data-stp-custom-size-add]');
      var errorEl = root.querySelector('[data-stp-custom-size-error]');
      var colors = cfg.colors || [];
      var color = colors.length ? colors[0] : null;
      var headImg = overlay.querySelector('.stp-custom-size__head img');

      function setColor(name) {
        colors.forEach(function (c) { if (c.name === name) color = c; });
        overlay.querySelectorAll('[data-stp-custom-size-color]').forEach(function (b) {
          b.setAttribute('aria-checked', String(color && b.getAttribute('data-stp-custom-size-color') === color.name));
        });
        if (color && headImg && color.image) headImg.src = color.image;
      }

      // The colour currently picked in the page's own variant picker.
      function pageColor() {
        var picked = null;
        document.querySelectorAll('variant-selects fieldset, variant-radios fieldset').forEach(function (fs) {
          var legend = fs.querySelector('legend');
          if (!legend || !/^\s*colou?r\s*$/i.test(legend.textContent)) return;
          var checked = fs.querySelector('input:checked');
          if (checked) picked = checked.value;
        });
        return picked;
      }

      // Move the overlay to <body> so no product-page stacking context
      // can trap it under the header.
      document.body.appendChild(overlay);

      rowsEl.innerHTML = sizes.map(function (s) {
        return '<div class="stp-custom-size__row">' +
          '<span class="stp-custom-size__size">' + s.size + ' inches</span>' +
          '<span class="stp-custom-size__price">' + money(s.price) + '</span>' +
          '<div class="stp-custom-size__qty" data-qty-for="' + s.id + '">' +
          '<button type="button" data-qty-step="-1" aria-label="Decrease">−</button>' +
          '<span data-qty-value>0</span>' +
          '<button type="button" data-qty-step="1" aria-label="Increase">+</button></div></div>';
      }).join('');

      // Typed size -> the smallest standard size at or above it.
      function otherState() {
        var raw = (otherInput.value || '').trim();
        if (!raw) return { empty: true };
        if (!/^\d+(\.\d)?$/.test(raw)) return { error: 'Use numbers only, up to one decimal (e.g. 4.5).' };
        var n = parseFloat(raw);
        if (n < minSize || n > maxSize) return { error: 'Enter a size between ' + minSize + ' and ' + maxSize + ' inches.' };
        var tier = sizes.filter(function (s) { return s.size >= n; })[0];
        return { value: raw, size: n, tier: tier };
      }

      function refresh() {
        var o = otherState();
        otherError.hidden = !o.error;
        otherError.textContent = o.error || '';
        otherPrice.textContent = o.tier ? money(o.tier.price) : '';
        var total = 0;
        var count = 0;
        sizes.forEach(function (s) { var q = qty[s.id] || 0; total += q * s.price; count += q; });
        var oq = qty.other || 0;
        if (oq && o.tier) { total += oq * o.tier.price; count += oq; }
        var otherBlocking = oq > 0 && !o.tier;
        addBtn.disabled = count === 0 || otherBlocking;
        addBtn.textContent = count ? 'Add ' + count + ' to cart · ' + money(total) : 'Add to cart';
      }

      overlay.addEventListener('click', function (e) {
        var step = e.target.closest('[data-qty-step]');
        if (step) {
          var box = step.closest('[data-qty-for]');
          var key = box.getAttribute('data-qty-for');
          var next = Math.max(0, Math.min(99, (qty[key] || 0) + Number(step.getAttribute('data-qty-step'))));
          qty[key] = next;
          box.querySelector('[data-qty-value]').textContent = next;
          refresh();
          return;
        }
        var colorBtn = e.target.closest('[data-stp-custom-size-color]');
        if (colorBtn) { setColor(colorBtn.getAttribute('data-stp-custom-size-color')); return; }
        if (e.target === overlay || e.target.closest('[data-stp-custom-size-close]')) close();
      });
      otherInput.addEventListener('input', function () {
        // Typing a size implies at least one piece of it.
        if ((qty.other || 0) === 0 && otherInput.value.trim()) {
          qty.other = 1;
          overlay.querySelector('[data-qty-for="other"] [data-qty-value]').textContent = '1';
        }
        refresh();
      });

      var lastFocus = null;
      function open() {
        lastFocus = document.activeElement;
        if (colors.length) setColor(pageColor() || color.name);
        overlay.hidden = false;
        document.body.classList.add('overflow-hidden');
        overlay.querySelector('[data-stp-custom-size-close]').focus();
      }
      function close() {
        overlay.hidden = true;
        document.body.classList.remove('overflow-hidden');
        if (lastFocus) lastFocus.focus();
      }
      root.querySelector('[data-stp-custom-size-open]').addEventListener('click', open);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !overlay.hidden) close();
      });

      addBtn.addEventListener('click', function () {
        var base = { Design: cfg.designTitle, _design_handle: cfg.designHandle, _design_image: cfg.designImage };
        if (color) {
          base.Colour = color.name;
          base._design_color = color.name;
          if (color.image) base._design_image = color.image;
        }
        var items = [];
        sizes.forEach(function (s) {
          if (qty[s.id]) items.push({ id: s.id, quantity: qty[s.id], properties: Object.assign({}, base) });
        });
        var o = otherState();
        if (qty.other && o.tier) {
          items.push({
            id: o.tier.id,
            quantity: qty.other,
            properties: Object.assign({}, base, { 'Custom Size (inches)': o.value }),
          });
        }
        if (!items.length) return;

        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var body = { items: items };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        addBtn.disabled = true;
        errorEl.hidden = true;
        addBtn.textContent = 'Adding…';
        fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw new Error(res.description || res.message || 'Could not add to cart');
            close();
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-size-popup', cartData: res });
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(res);
              cart.classList.remove('is-empty');
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
            // Reset for a next add.
            qty = {};
            otherInput.value = '';
            overlay.querySelectorAll('[data-qty-value]').forEach(function (el) { el.textContent = '0'; });
            refresh();
          })
          .catch(function (err) {
            errorEl.textContent = err.message || 'Could not add to cart. Please try again.';
            errorEl.hidden = false;
            refresh();
          });
      });

      refresh();
    }

    document.querySelectorAll('[data-stp-custom-size]').forEach(init);
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-stp-custom-size]').forEach(init);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ganesha-mascot"] && !Shopify.designMode) return;
  try {
    (function () {
  // Dismissing the mascot only hides it for the current page view — no
  // persistence across refreshes/navigations, so it comes back every time
  // the page loads (Akshat's call, Sep 15 2026: closing it shouldn't make
  // it gone for the rest of the day).
  function initMascot(mascot) {
    mascot.hidden = false;

    var bubble = mascot.querySelector('[data-ganesha-mascot-bubble]');
    var openTimer = null;
    var closeTimer = null;

    if (bubble) {
      var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!prefersReduced) {
        openTimer = window.setTimeout(function () {
          bubble.classList.add('is-open');
          closeTimer = window.setTimeout(function () {
            bubble.classList.remove('is-open');
          }, 4500);
        }, 900);
      }
    }

    var closeButton = mascot.querySelector('[data-ganesha-mascot-close]');
    if (closeButton) {
      closeButton.addEventListener('click', function (event) {
        event.preventDefault();
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        mascot.hidden = true;
      });
    }
  }

  var mascots = document.querySelectorAll('[data-ganesha-mascot]');
  mascots.forEach(initMascot);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rewards-teaser"] && !Shopify.designMode) return;
  try {
    (function () {
  function initRewardsTeaser(root) {
    var openBtn = root.querySelector('[data-rewards-teaser-open]');
    var overlay = root.querySelector('[data-rewards-teaser-overlay]');
    var closeEls = root.querySelectorAll('[data-rewards-teaser-close]');
    if (!openBtn || !overlay) return;

    function playVideos() {
      root.querySelectorAll('video').forEach(function (v) {
        if (!v.getAttribute('src')) return;
        v.play().catch(function () {
          /* autoplay blocked -- poster image stays visible, harmless */
        });
      });
    }

    function open() {
      overlay.hidden = false;
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
      });
      document.documentElement.style.overflow = 'hidden';
      playVideos();
    }

    function close() {
      overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      window.setTimeout(function () {
        overlay.hidden = true;
      }, 320);
    }

    openBtn.addEventListener('click', open);
    closeEls.forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });

    // "Show it off" step video -- tap the small looping preview to open a
    // full-size, sound-on player, same video.
    var videoLightbox = root.querySelector('[data-rewards-teaser-video-lightbox]');
    var videoPlayBtn = root.querySelector('[data-rewards-teaser-play-video]');
    var lightboxCloseEls = root.querySelectorAll('[data-rewards-teaser-video-close]');
    var lightboxPlayer = root.querySelector('[data-rewards-teaser-video-player]');
    var stepPreview = root.querySelector('.stp-rewards-teaser__step-video');

    function openVideoLightbox() {
      if (!videoLightbox || !lightboxPlayer) return;
      if (stepPreview) stepPreview.pause();
      videoLightbox.hidden = false;
      requestAnimationFrame(function () {
        videoLightbox.classList.add('is-open');
      });
      lightboxPlayer.currentTime = 0;
      lightboxPlayer.play().catch(function () {
        /* autoplay-with-sound blocked -- controls are visible, user taps play */
      });
    }

    function closeVideoLightbox() {
      if (!videoLightbox || !lightboxPlayer) return;
      videoLightbox.classList.remove('is-open');
      lightboxPlayer.pause();
      window.setTimeout(function () {
        videoLightbox.hidden = true;
      }, 250);
      if (stepPreview) stepPreview.play().catch(function () {});
    }

    if (videoPlayBtn) {
      videoPlayBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        openVideoLightbox();
      });
    }
    lightboxCloseEls.forEach(function (el) {
      el.addEventListener('click', closeVideoLightbox);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && videoLightbox && !videoLightbox.hidden) closeVideoLightbox();
    });

    // Lazy-load: only set the trigger's own ring video src once it's near
    // the viewport, so this doesn't cost bandwidth on every PDP load.
    var ringVideo = root.querySelector('.stp-rewards-teaser__ring-video');
    if (ringVideo && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            ringVideo.play().catch(function () {});
            io.unobserve(ringVideo);
          }
        });
      }, { threshold: 0.5 });
      io.observe(ringVideo);
    }
  }

  document.querySelectorAll('[data-rewards-teaser]').forEach(initRewardsTeaser);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["support-chat-launcher"] && !Shopify.designMode) return;
  try {
    (function () {
  function initSupportChat(root) {
    var openButton = root.querySelector('[data-support-chat-open]');
    var overlay = root.querySelector('[data-support-chat-overlay]');
    var closeButton = root.querySelector('[data-support-chat-close]');
    var frame = root.querySelector('[data-support-chat-frame]');
    if (!openButton || !overlay || !closeButton || !frame) return;

    var lockedScrollY = 0;
    var bridge = null;

    function open() {
      if (!frame.src) {
        frame.src = frame.getAttribute('data-src');
      }
      overlay.hidden = false;
      if (bridge) bridge.sendCart();
      lockedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + lockedScrollY + 'px';
      document.body.style.width = '100%';
      closeButton.focus();
    }

    function close() {
      overlay.hidden = true;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, lockedScrollY);
      openButton.focus();
    }

    bridge = initCartBridge(root, overlay, frame, close);

    openButton.addEventListener('click', open);
    closeButton.addEventListener('click', close);
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) close();
    });
    document.addEventListener('keydown', function (event) {
      // Escape inside the in-chat variant picker closes just the picker.
      if (event.key === 'Escape' && !overlay.hidden && !document.querySelector('quick-add-modal.support-chat-quick-add[open]')) close();
    });
  }

  // --- In-chat Add to Cart bridge (v2) -----------------------------------
  var CHAT_ORIGIN = 'https://customer.slapthatpatch.com';

  function initCartBridge(root, overlay, frame, closeChat) {
    var opener = root.querySelector('[data-support-chat-quick-opener]');

    function post(msg) {
      if (frame.contentWindow) frame.contentWindow.postMessage(msg, CHAT_ORIGIN);
    }
    function reply(requestId, ok, error, cancelled) {
      post({ type: 'stp-chat:cart-result', requestId: requestId, ok: ok, error: error || null, cancelled: !!cancelled });
    }
    function announce() {
      post({ type: 'stp-chat:host-ready', productHandle: root.getAttribute('data-product-handle') || null, customiser: Boolean(root.getAttribute('data-cx-art')) });
      sendCart();
    }
    // Live cart value (pre-discount subtotal, same figure the rewards bar
    // uses) so Divya knows how far the shopper is from free shipping/gifts.
    function sendCart() {
      fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          post({ type: 'stp-chat:cart', subtotal: cart.items_subtotal_price / 100, itemCount: cart.item_count });
        })
        .catch(function () {});
    }
    function watchCart() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(sendCart, 300); });
      }
    }
    // pubsub.js is a deferred script -- may not have run yet.
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCart);
    else watchCart();

    function getCart() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }
    // Never open the cart drawer/notification while the chat is showing --
    // its focus trap would pull focus out of the chat iframe. Contents
    // still update (renderContents); "View cart" opens it explicitly.
    function patchCart() {
      var cart = getCart();
      if (!cart || cart.__stpChatPatched || typeof cart.open !== 'function') return cart;
      var originalOpen = cart.open.bind(cart);
      cart.__stpChatPatched = true;
      cart.__stpOriginalOpen = originalOpen;
      cart.open = function () {
        if (!overlay.hidden) return;
        return originalOpen.apply(null, arguments);
      };
      return cart;
    }

    function addVariant(requestId, variantId) {
      if (!/^[0-9]+$/.test(String(variantId))) return reply(requestId, false, 'Invalid product');
      var cart = patchCart();
      var body = new FormData();
      body.append('id', String(variantId));
      body.append('quantity', '1');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        body.append('sections_url', window.location.pathname);
      }
      fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: body,
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) return reply(requestId, false, res.description || res.message || 'Could not add to cart');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'support-chat', productVariantId: String(variantId), cartData: res });
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(res);
            cart.classList.remove('is-empty');
          }
          reply(requestId, true);
        })
        .catch(function () { reply(requestId, false, 'Could not add to cart'); });
    }

    var assetsPromise = null;
    function loadQuickAddAssets() {
      if (assetsPromise) return assetsPromise;
      (root.getAttribute('data-quick-add-assets') || '').split('|').forEach(function (href) {
        if (!href || document.querySelector('link[href="' + href + '"]')) return;
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      });
      var needed = { 'product-info.js': 'product-info', 'product-form.js': 'product-form', 'quick-add.js': 'quick-add-modal' };
      var loads = (root.getAttribute('data-quick-add-scripts') || '').split('|').map(function (src) {
        var name = Object.keys(needed).filter(function (k) { return src.indexOf(k) !== -1; })[0];
        if (!src || (name && customElements.get(needed[name]))) return Promise.resolve();
        return new Promise(function (resolve, reject) {
          var el = document.createElement('script');
          el.src = src;
          el.onload = resolve;
          el.onerror = reject;
          document.head.appendChild(el);
        });
      });
      assetsPromise = Promise.all(loads).then(function () {
        return customElements.whenDefined('quick-add-modal');
      });
      return assetsPromise;
    }

    function quickAdd(requestId, productUrl) {
      var path = null;
      try {
        path = new URL(productUrl, window.location.origin).pathname;
      } catch (e) {}
      if (!path || !/^\/products\/[A-Za-z0-9_-]+$/.test(path)) return reply(requestId, false, 'Invalid product');
      patchCart();
      loadQuickAddAssets()
        .then(function () {
          var modal = document.getElementById('QuickAdd-stp-chat');
          if (!modal || typeof modal.show !== 'function') throw new Error('no modal');
          var finished = false;
          var unsubscribe = null;
          function finish(ok, cancelled) {
            if (finished) return;
            finished = true;
            if (unsubscribe) unsubscribe();
            document.body.removeEventListener('modalClosed', onClosed);
            reply(requestId, ok, null, cancelled);
          }
          function onClosed() {
            // product-form publishes cartUpdate BEFORE it closes the modal,
            // so a close with no add first means the customer cancelled.
            setTimeout(function () { finish(false, true); }, 300);
          }
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
              if (event && event.source === 'product-form') finish(true, false);
            });
          }
          document.body.addEventListener('modalClosed', onClosed);
          opener.setAttribute('data-product-url', path);
          modal.show(opener);
        })
        .catch(function () { reply(requestId, false, 'Could not open the size options'); });
    }

    // --- In-chat customiser (Oct 19 2026) ------------------------------
    // The widget's guided "make your own text / photo patch" flow. Renders
    // with the SAME engine and fonts as the "Customise Your Own Text"
    // product page (cx-names-art.js) and adds lines with the same
    // properties, so Operations OS prints chat orders exactly like
    // product-page orders.
    var cxFonts = [];
    try { cxFonts = JSON.parse(root.getAttribute('data-cx-fonts') || '[]'); } catch (e) {}
    var cxReady = null;
    function ensureCustomiser() {
      if (cxReady) return cxReady;
      var css = cxFonts.map(function (f) {
        return "@font-face{font-family:'" + f.family + "';src:url('" + f.url + "') format('woff2');font-display:swap;}";
      }).join('');
      var style = document.createElement('style');
      style.textContent = css;
      document.head.appendChild(style);
      cxReady = window.CXNamesArt
        ? Promise.resolve()
        : new Promise(function (resolve, reject) {
            var el = document.createElement('script');
            el.src = root.getAttribute('data-cx-art');
            el.onload = resolve;
            el.onerror = reject;
            document.head.appendChild(el);
          });
      cxReady = cxReady.then(function () {
        if (!window.CXNamesArt) throw new Error('customiser unavailable');
      });
      cxReady.catch(function () { cxReady = null; });
      return cxReady;
    }
    function customReply(requestId, ok, data, error) {
      post({ type: 'stp-chat:custom-result', requestId: requestId, ok: ok, data: data || null, error: error || null });
    }
    function cxFont(label) {
      return cxFonts.filter(function (f) { return f.label === label; })[0] || cxFonts[0];
    }
    function cxFill(fill) {
      var A = window.CXNamesArt;
      var name = (fill && fill.name) || 'White';
      var g = A.GRADIENTS.filter(function (x) { return x[0] === name; })[0];
      if (fill && fill.type === 'gradient' && g) return { type: 'gradient', name: g[0], stops: g[1] };
      var sd = A.SOLIDS.filter(function (x) { return x[0] === name; })[0] || A.SOLIDS[1];
      return { type: 'solid', name: sd[0], color: sd[1] };
    }
    function cxOutline(o) {
      return o === 'White' ? '#ffffff' : o === 'Black' ? '#111111' : null;
    }
    function cxCompose(design, maxSide) {
      return window.CXNamesArt.compose({
        text: String(design.text || '').slice(0, 20),
        fontFamily: cxFont(design.font).family,
        fill: cxFill(design.fill),
        outline: cxOutline(design.outline),
        icon: null,
        maxSide: maxSide,
      }).then(function (r) { return r.canvas; });
    }

    function customConfig(requestId) {
      ensureCustomiser()
        .then(function () {
          var A = window.CXNamesArt;
          customReply(requestId, true, {
            fonts: cxFonts.map(function (f) { return f.label; }),
            solids: A.SOLIDS.map(function (x) { return { name: x[0], color: x[1] }; }),
            gradients: A.GRADIENTS.map(function (x) { return { name: x[0], stops: x[1] }; }),
          });
        })
        .catch(function () { customReply(requestId, false, null, 'Customiser could not load'); });
    }

    function renderText(requestId, data) {
      var fonts = (Array.isArray(data.fonts) ? data.fonts : []).slice(0, 16);
      var side = Math.min(Math.max(Number(data.maxSide) || 360, 120), 900);
      ensureCustomiser()
        .then(function () {
          return Promise.all(fonts.map(function (label) {
            return cxCompose({ text: data.text, font: label, fill: data.fill, outline: data.outline }, side).then(function (c) {
              return { font: label, url: c.toDataURL('image/png') };
            });
          }));
        })
        .then(function (images) { customReply(requestId, true, { images: images }); })
        .catch(function () { customReply(requestId, false, null, 'Could not render the preview'); });
    }

    function postCartForm(body, variantId) {
      var cart = patchCart();
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        body.append('sections_url', window.location.pathname);
      }
      return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: body,
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || 'Could not add to cart');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'support-chat', productVariantId: String(variantId), cartData: res });
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(res);
            cart.classList.remove('is-empty');
          }
          return res;
        });
    }

    function addCustom(requestId, data) {
      if (!/^[0-9]+$/.test(String(data.variantId))) return customReply(requestId, false, null, 'Invalid product');
      var body = new FormData();
      body.append('id', String(data.variantId));
      body.append('quantity', '1');
      var ready;
      if (data.kind === 'text') {
        var d = data.design || {};
        var text = String(d.text || '').trim().slice(0, 20);
        if (!text) return customReply(requestId, false, null, 'Missing text');
        ready = ensureCustomiser()
          .then(function () { return cxCompose(d, 2400); })
          .then(function (canvas) {
            return new Promise(function (resolve, reject) {
              canvas.toBlob(function (blob) { blob ? resolve(blob) : reject(new Error('Could not prepare your design')); }, 'image/png');
            });
          })
          .then(function (blob) {
            var fillName = cxFill(d.fill).type === 'gradient' ? cxFill(d.fill).name + ' gradient' : cxFill(d.fill).name;
            // Same properties as the product page (custom-personalization-
            // text-plus.js lineProperties); never "Custom Text"/"Font"/"Color".
            body.append('properties[Custom Image]', new File([blob], 'text-patch.png', { type: 'image/png' }));
            body.append('properties[Your Text]', text);
            body.append('properties[Lettering]', cxFont(d.font).label);
            body.append('properties[Fill]', fillName);
            if (d.outline === 'White' || d.outline === 'Black') body.append('properties[Outline]', d.outline);
            body.append('properties[_cx_design]', JSON.stringify({ t: text, f: cxFont(d.font).label, c: fillName, o: d.outline === 'White' || d.outline === 'Black' ? d.outline : 'None', i: null }));
            body.append('properties[_chat]', 'Support chat');
          });
      } else if (data.kind === 'image' && data.file instanceof Blob) {
        var type = data.file.type || 'image/jpeg';
        var ext = type === 'image/png' ? 'png' : type === 'image/webp' ? 'webp' : 'jpg';
        body.append('properties[Custom Image]', new File([data.file], 'chat-photo.' + ext, { type: type }));
        body.append('properties[_chat]', 'Support chat');
        ready = Promise.resolve();
      } else {
        return customReply(requestId, false, null, 'Invalid design');
      }
      ready
        .then(function () { return postCartForm(body, data.variantId); })
        .then(function () { customReply(requestId, true, {}); })
        .catch(function (e) { customReply(requestId, false, null, (e && e.message) || 'Could not add to cart'); });
    }

    function openCart() {
      closeChat();
      var cart = getCart();
      if (cart && cart.__stpOriginalOpen) cart.__stpOriginalOpen();
      else if (cart && typeof cart.open === 'function') cart.open();
      else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }

    frame.addEventListener('load', announce);
    window.addEventListener('message', function (event) {
      if (event.origin !== CHAT_ORIGIN || event.source !== frame.contentWindow) return;
      var data = event.data || {};
      if (data.type === 'stp-chat:hello') announce();
      else if (data.type === 'stp-chat:get-cart') sendCart();
      else if (data.type === 'stp-chat:add-to-cart') addVariant(data.requestId, data.variantId);
      else if (data.type === 'stp-chat:quick-add') quickAdd(data.requestId, data.productUrl);
      else if (data.type === 'stp-chat:open-cart') openCart();
      else if (data.type === 'stp-chat:custom-config') customConfig(data.requestId);
      else if (data.type === 'stp-chat:render-text') renderText(data.requestId, data);
      else if (data.type === 'stp-chat:add-custom') addCustom(data.requestId, data);
    });

    return { sendCart: sendCart };
  }

  var roots = document.querySelectorAll('[data-support-chat-launcher]');
  roots.forEach(initSupportChat);
})();
  } catch(e) { console.error(e); }
})();

})();
